
  import { defineComponent, ref, onMounted, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';

  export default defineComponent({
    name: 'taxi-meter-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('taxiMeterListing'), [
          translate('assets'),
        ]);
        loading.value = true;
        await store.dispatch(Actions.GET_TAXI_METERS);
        loading.value = false;
      });

      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('from city'),
          key: 'fromGovernorateTitle',
          sortable: true,
        },
        {
          name: translate('to city'),
          key: 'toGovernorateTitle',
          sortable: true,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);
      const deleteTaxiMeter = async (taxiMeter) => {
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_TAXI_METER, taxiMeter.id);
          await store.dispatch(Actions.GET_TAXI_METERS);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          }
        }
      };

      const editTaxiMeter = (id) => {
        router.push({ name: 'taxi-meter-editing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_TAXI_METER_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_TAXI_METERS);
        loading.value = false;
      };

      return {
        tableData: computed(() => store.getters.taxiMeterList),
        tableHeader,
        deleteTaxiMeter,
        translate,
        totalItems: computed(() => store.getters.taxiMeterListCount),
        pageChanged,
        goTo,
        editTaxiMeter,
        loading,
        can,
      };
    },
  });
